// /support — Support page (public, no auth). Static page without a data
// layer: the wording lives in the `legal.support.*` i18n catalog (draft text;
// the owner approves the final edit via PR review).

import type { ReactElement } from 'react';

import { LegalPageLayout, type LegalSection } from './LegalPageLayout.js';

/** Revision of the current draft; update together with the catalog wording. */
const SUPPORT_REVISION_DATE = new Date(2026, 9, 21);

const SECTIONS: readonly LegalSection[] = [
  {
    titleKey: 'crm.legal.support.email.title',
    bodyKey: 'crm.legal.support.email.body',
  },
  {
    titleKey: 'crm.legal.support.response.title',
    bodyKey: 'crm.legal.support.response.body',
  },
  {
    titleKey: 'crm.legal.support.status.title',
    bodyKey: 'crm.legal.support.status.body',
  },
];

export function SupportPage(): ReactElement {
  return (
    <LegalPageLayout
      titleKey="crm.legal.support.title"
      introKey="crm.legal.support.intro"
      updatedKey="crm.legal.updated"
      revisionDate={SUPPORT_REVISION_DATE}
      sections={SECTIONS}
      relatedLinks={[
        { to: '/terms', labelKey: 'crm.legal.link.terms' },
        { to: '/privacy', labelKey: 'crm.legal.link.privacy' },
      ]}
    />
  );
}
